import * as React from 'react';
import cx from 'classnames';
import { string, oneOf, bool, oneOfType, number } from 'prop-types';
import style from './Card.module.scss';
import { Box } from '../Layout';

const Card = ({ className, width, scrollable, ...rest }) => {
  return (
    <Box
      className={cx(className, style.card, style[width], scrollable && style.scrollable)}
      {...rest}
    />
  );
};

Card.propTypes = {
  className: string,
  p: oneOfType([string, number]),
  width: oneOf(['auto', 'medium', 'max']),
  scrollable: bool,
};

Card.defaultProps = {
  p: 'xsmall',
  width: 'auto',
};

export default Card;
